import { render, staticRenderFns } from "./apinv-request.vue?vue&type=template&id=31c5d1e9"
import script from "./apinv-request.vue?vue&type=script&lang=js"
export * from "./apinv-request.vue?vue&type=script&lang=js"
import style0 from "./apinv-request.vue?vue&type=style&index=0&id=31c5d1e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports